import React from 'react';
import { Alert, Chip, Stack } from '@mui/material';
import type { ScanControlRelationView } from '../../domain/safetyCases/scanControlTemporalRelation';

export function ScanControlRelationDisclosure({
  relation,
}: {
  relation?: ScanControlRelationView | null;
}) {
  if (!relation?.label) return null;
  return (
    <Stack spacing={0.75} data-testid="scan-layer-a-control-relation" data-relation={relation.relation}>
      <Chip
        size="small"
        color={relation.relation === 'CROSSING' ? 'warning' : 'default'}
        variant={relation.relation === 'CROSSING' ? 'outlined' : 'filled'}
        label={relation.label}
        data-testid="scan-control-relation-buyer-label"
      />
      {relation.customerCopy ? (
        <Alert severity="warning" data-testid="scan-layer-a-crossing-copy">
          {relation.customerCopy}
        </Alert>
      ) : null}
    </Stack>
  );
}

export default ScanControlRelationDisclosure;
